import { TopicflowIconType } from "@components/topicflow-icon/topicflow-icon-helpers";

import { OnboardingMetricKey } from "../helpers/onboarding";

export type OnboardingMetric = {
  key: OnboardingMetricKey;
  label: string;
  iconType: TopicflowIconType;
};

// The three onboarding checklist actions shown in the manager checklist popover, in order.
export const ONBOARDING_METRICS: OnboardingMetric[] = [
  { key: "toldAboutReport", label: "Start onboarding", iconType: "route" },
  {
    key: "hasRecurringOneonone",
    label: "Schedule 1:1",
    iconType: "calendarPlus",
  },
  { key: "invited", label: "Invite to app", iconType: "userPlus02" },
];
